import { useState, useEffect } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import Modal from './Modal';
import { fetchHelpDoc } from '../services/api';
import './HelpDocPopup.css';

// Make all links open in a new tab
marked.use({
  renderer: {
    link({ href, title, text }) {
      return `<a href="${href}" ${title ? `title="${title}"` : ''} target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
  },
});

/**
 * Reusable help-documentation popup.
 *
 * Props:
 *   show     — visibility toggle
 *   docName  — help doc name (without .md), e.g. "gitee_token"
 *   title    — modal title (default "Help")
 *   onClose  — () => void
 */
export default function HelpDocPopup({ show, docName, title = 'Help', onClose }) {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show || !docName) return;
    setLoading(true);
    setError('');
    fetchHelpDoc(docName)
      .then(data => setHtml(DOMPurify.sanitize(marked.parse(data.content))))
      .catch(err => setError(err.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }, [show, docName]);

  return (
    <Modal
      show={show}
      title={title}
      onClose={onClose}
      modalStyle={{ height: 'auto', maxHeight: '80vh' }}
    >
      <div>
        {loading && <div style={{ color: 'var(--ink-muted)', fontSize: 'var(--text-sm)', textAlign: 'center', padding: 'var(--space-lg) 0' }}>Loading…</div>}
        {error && <div style={{ color: 'var(--danger)', fontSize: 'var(--text-sm)', textAlign: 'center', padding: 'var(--space-lg) 0' }}>{error}</div>}
        {!loading && !error && html && (
          <div className="help-doc-content" dangerouslySetInnerHTML={{ __html: html }} />
        )}
      </div>
    </Modal>
  );
}
